import MakePresenter from "presenters/MakePresenter";
import { trackMakeEvent, IN_FLOW_SUBSCRIPTION_PURCHASE } from "utils/makeEventUtils";

import useAlgoliaEvents from "./useAlgoliaEvents";
import useAlgoliaTracker from "./useAlgoliaTracker";
import useMakes from "./useMakes";

const usePaymentEvents = () => {
  const { trackEventAfterSearchAndPurchase } = useAlgoliaEvents();
  const { hitSelected } = useAlgoliaTracker();
  const { make, updateMake } = useMakes();

  const onSuccessfulInFlowPayment = async () => {
    if (MakePresenter.templateGroupId(make) === hitSelected?.objectID) trackEventAfterSearchAndPurchase(hitSelected);
    await trackMakeEvent(make, IN_FLOW_SUBSCRIPTION_PURCHASE);
    await updateMake(make);
  };

  return { onSuccessfulInFlowPayment };
};

export default usePaymentEvents;
